import { render, staticRenderFns } from "./JobHistoryList.vue?vue&type=template&id=56c24777&"
import script from "./JobHistoryList.vue?vue&type=script&lang=js&"
export * from "./JobHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./JobHistoryList.vue?vue&type=style&index=0&id=56c24777&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports